import { render } from "./SubmissionRuleEditor.vue?vue&type=template&id=7cbc872e&scoped=true"
import script from "./SubmissionRuleEditor.vue?vue&type=script&lang=js"
export * from "./SubmissionRuleEditor.vue?vue&type=script&lang=js"

import "./SubmissionRuleEditor.vue?vue&type=style&index=0&id=7cbc872e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbc872e"]])

export default __exports__